import useFeaturePermissions from './useFeaturePermissions';
import { Permissions } from '@auth/permissions.ts';

/**
 * Get the permission of the entity salutation
 * @param organizationId
 * @returns An object containing the write and read permissions
 */
export const useSalutationsPermissions = (organizationId: string) => {
  const { writePermission, readPermission } = useFeaturePermissions(organizationId, Permissions.SalutationsChange, Permissions.SalutationsRead);
  return { writePermission, readPermission };
};
